export default (node:any, params:any, options:any) => {
  return node
}